<template>
    <div>
        <template v-if="isPageAllowed">
            <div class="wrap full-h">
                <div class="left full-h" style="height: calc(100vh - 80px);">
                    <CompanyListCard @calcTableHeight="calcTableHeight" ref="companyListCard" @checked="changeCustomer" :active-item="activeCustomer" />
                </div>
                <div class="right pl10 full-h" style="height: calc(100vh - 80px);">
                    <div class="filter-bar mb10">
                        <el-form :inline="true" @submit.native.prevent="submitSearch">
                            <el-form-item label="推广：">
                                <el-input v-model="tempQuery.search" @keyup.enter.native="submitSearch" @clear="submitSearch" clearable placeholder="推广名称、ID、内容" style="width: 220px;">
                                    <el-button slot="append" icon="el-icon-search" @click="submitSearch"></el-button>
                                </el-input>
                            </el-form-item>
                            <el-form-item label="媒体：">
                                <el-select 
                                    v-model="queryData.plat_ids"
                                    @change="platChange" 
                                    placeholder="全部媒体" 
                                    style="width: 200px;"
                                >
                                    <el-option v-for="item in optionListData.plat_id"
                                               :label="item.name"
                                               :value="item.id"
                                               :key="item.id">{{item.name}}
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="绑定状态：" prop="status">
                                <el-select v-model="queryData.status" @change="submitSearch" clearable placeholder="全部" style="width: 120px;">
                                    <el-option label="全部" value="">全部</el-option>
                                    <el-option label="启用" value="1"></el-option>
                                    <el-option label="停用" value="0"></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="特殊产品：" prop="status">
                                <div slot="label">
                                    <el-popover
                                        placement="top-start"
                                        title=""
                                        width="400"
                                        trigger="hover">
                                        <span slot="reference">特殊产品<i class="el-icon-question"></i>：</span>

                                        <ul class="pl20" style="list-style: disc;">
                                            <li>此处查询与权限无关，若存在即显示，可能因为权限原因无法显示绑定的全部客户。</li>
                                            <li>多个启用客户：一个产品绑定了多个客户，且均为启用状态。</li>
                                            <li>多个绑定客户：一个产品绑定了多个客户，无论是否启用。</li>
                                            <li>未绑定客户：未绑定客户的产品。</li>
                                            <li>全部停用：产品绑定的客户均为停用状态。</li>
                                        </ul>
                                    </el-popover>
                                </div>
                                <el-select 
                                    v-model="queryData.special_app" 
                                    @change="specialAppChange" 
                                    clearable 
                                    placeholder="全部" 
                                    style="width: 150px;"

                                >
                                    <el-option label="全部" value="">全部</el-option>
                                    <el-option label="多个启用客户" value="1"></el-option>
                                    <el-option label="多个绑定客户" value="2"></el-option>
                                    <el-option label="未绑定客户" value="4"></el-option>
                                    <el-option label="全部停用" value="3"></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="修改人：">
                                <ESelect :value="queryData.modify_name" @change="(val)=>changeData(val, 'modify_name')" filterable multiple collapse-tags clearable placeholder="搜索或下拉选择" style="width: 150px;">
                                    <el-option value="all-option">全选</el-option>
                                    <el-option v-for="item in optionListData.modify_name" :label="item.name" :value="item.id" :key="item.id">
                                        {{item.name}}
                                    </el-option>
                                </ESelect>
                            </el-form-item>
                             <el-form-item label="创建人：">
                                <ESelect :value="queryData.creator_name" @change="(val)=>changeData(val, 'creator_name')" filterable multiple collapse-tags clearable placeholder="搜索或下拉选择" style="width: 150px;">
                                    <el-option value="all-option">全选</el-option>
                                    <el-option v-for="item in optionListData.creator_name" :label="item.name" :value="item.id" :key="item.id">
                                        {{item.name}}
                                    </el-option>
                                </ESelect>
                            </el-form-item>
                            <el-form-item label="修改时间：">
                                <el-date-picker
                                    v-model="tempQuery.modify_time"
                                    @change="submitSearch"
                                    style="width: 220px"
                                    type="daterange"
                                    align="center"
                                    unlink-panels
                                    :picker-options="pickerOptions"
                                    value-format="yyyy-MM-dd"
                                    range-separator="~"
                                    start-placeholder="开始日期"
                                    end-placeholder="结束日期">
                                </el-date-picker>
                            </el-form-item>
                             <el-form-item label="创建时间：">
                                <el-date-picker
                                    v-model="queryData.create_time"
                                    @change="submitSearch"
                                    style="width: 220px"
                                    type="daterange"
                                    align="center"
                                    unlink-panels
                                    :picker-options="pickerOptions"
                                    value-format="yyyy-MM-dd"
                                    range-separator="~"
                                    start-placeholder="开始日期"
                                    end-placeholder="结束日期">
                                </el-date-picker>
                            </el-form-item>
                             <el-form-item label="认证状态：" prop="is_auth">
                                <el-select v-model="queryData.is_auth" @change="submitSearch" clearable placeholder="全部" style="width: 120px;">
                                    <el-option label="全部" value="">全部</el-option>
                                    <el-option 
                                        v-for="item in optionListData.is_auth" 
                                        :label="item.name" 
                                        :value="item.id"
                                        :key="item.id"
                                    />
                                </el-select>
                            </el-form-item>
                            <el-form-item label="产品类型：" prop="app_type">
                                <el-select v-model="queryData.app_type" @change="submitSearch" clearable placeholder="全部" style="width: 120px;">
                                    <el-option label="全部" value="">全部</el-option>
                                    <el-option 
                                        v-for="item in optionListData.app_type" 
                                        :label="item.name" 
                                        :value="item.id"
                                        :key="item.id"
                                    />
                                </el-select>
                            </el-form-item>
                            <el-form-item label="游戏分类：" prop="game_classify">
                                <el-select v-model="queryData.game_classify" @change="submitSearch" clearable placeholder="全部" style="width: 120px;">
                                    <el-option label="全部" value="">全部</el-option>
                                    <el-option 
                                        v-for="item in optionListData.game_classify" 
                                        :label="item.name" 
                                        :value="item.id"
                                        :key="item.id"
                                    />
                                </el-select>
                            </el-form-item>
                            <el-form-item label="包体类型：" prop="package_type">
                                <el-select v-model="queryData.package_type" multiple collapse-tags @change="submitSearch" clearable placeholder="请选择，可多选" style="width: 150px;">
                                    <el-option 
                                        v-for="item in optionListData.package_type" 
                                        :label="item.name" 
                                        :value="item.id"
                                        :key="item.id"
                                    />
                                </el-select>
                            </el-form-item>
                            <el-form-item :prop="item.name" v-for="item in formList" :label='item.display_name' :key="item.id">
                                <el-input v-model="queryData.other[item.name]" placeholder="请输入" style="width:180px" @change="submitSearch"/>
                            </el-form-item>
                        </el-form>
                    </div>
                    <div class="table-tool-bar clear-both">
                        <div class="fl">
                            <el-button type="primary" icon="el-icon-plus" @click="handleAddAppClick">录入新产品</el-button>
                            <span class="pl10 pr10">|</span>
                            <el-button type="primary" @click="showBatchBindModal" v-if="pageFuncNames.includes('bind_app_new')" size="mini" class="" v-matomo="{behaviorCategory: '客户产品管理',name: '批量绑定客户' }" plain>批量绑定客户</el-button>
                            <el-button type="primary" @click="editPersonInCharge" v-if="pageFuncNames.includes('edit_create_user')"    size="mini" class="" v-matomo="{behaviorCategory: '客户产品管理',name: '批量修改负责人' }" plain>批量修改负责人</el-button>
                            <el-button type="success" :disabled="dataSelected.length<=0" @click="batchEnable" v-if="pageFuncNames.includes('enable')" :loading="batchEnableLoading" size="mini" v-matomo="{behaviorCategory: '客户产品管理',name: '批量启用' }">批量启用</el-button>
                            <el-button type="danger" :disabled="dataSelected.length<=0" @click="batchDisable" v-if="pageFuncNames.includes('disable')" :loading="batchDisableLoading" size="mini" class="mr20" v-matomo="{behaviorCategory: '客户产品管理',name: '批量停用' }">批量停用</el-button>
                        </div>
                        <div class="fr pr20">
                            <el-button @click="exportData" :loading="exportLoading" size="mini" v-matomo="{behaviorCategory: '客户产品管理',name: '导出' }">导出</el-button>
                            <!-- <p v-if="unbindNum>0" class="inline-block relative top10">
                                <span class="text-color-error"><i class="icon iconfont icon-jt-tongzhi pr4 info-tip-icon"></i>当前有 {{unbindNum}} 个产品未绑定客户，请及时绑定！</span>
                                <el-link type="primary" class="mr20 vertical-bottom" @click="showUnbindListModal">立即查看</el-link>
                            </p> -->
                        </div>
                        <p class="tips text-color-gray pl10 mt4 fl full-w">已选中 {{dataSelected.length}} 条</p>
                    </div>
                    <div class="data-list mb20">
                        <div class="relative">
                            <div class="table-wrap absolute full-w">
                                <el-table
                                    ref="dataTable"
                                    :data="dataList"
                                    v-loading="dataLoading"
                                    @selection-change="selectionChange"
                                    tooltip-effect="dark"
                                    :header-cell-style="{background:'#e8eaec',color:'#333'}"
                                    :height="tableHeight"
                                    stripe
                                    style="width: 100%;">
                                    <el-table-column
                                        fixed="left"
                                        type="selection"
                                        align="center"
                                        :key="column.left"
                                        width="55">
                                    </el-table-column>
                                    <el-table-column
                                        min-width="180"
                                        :prop="item.name"
                                        v-for="(item, index) in column"
                                        :key="index"
                                        show-overflow-tooltip
                                        :fixed="index === 0"
                                    >
                                        <template v-slot:header>
                                            {{item.display_name}}
                                            <el-tooltip v-if="item.name === 'is_auth'"  effect="dark" placement="top">
                                                <div slot="content">
                                                    1、未认证：未经过媒体认证，无法与媒体基础信息关联，准确性无法确认。
                                                    <br/>
                                                    2、已认证：经过媒体认证的产品信息，可与媒体基础信息相关联，准确性经过媒体确认。
                                                    <br/>
                                                    3、基础信息指该产品创建的计划、广告组、广告等基建信息。在媒体搭建广告并且聚投获取到后会自动关联认证。
                                                </div>
                                                <i class="el-icon-question"></i>
                                            </el-tooltip>
                                        </template>
                                        <template slot-scope="scope" >
                                            <div v-if="item.name === 'is_auth'">
                                                <span v-if="scope.row.is_auth==='0'" style="color: #D9001B">未认证</span>
                                                <span v-if="scope.row.is_auth==='1'" style="color: #63A103" >已认证</span>
                                            </div>
                                            <div v-else-if="item.name === 'status_name'">
                                                <span class="text-color-success" v-if="scope.row.status=='1'">启用</span>
                                                <span class="text-color-error" v-else-if="scope.row.status=='0'">停用</span>
                                                <span v-else>--</span>
                                            </div>
                                            <div v-else-if="item.name === 'customer_id'">
                                                <template v-if="scope.row.customer_id.length>0">
                                                        <el-tooltip class="item" effect="dark" :content="scope.row.customer_list_str" placement="top-start">
                                                            <div class="ellipsis">{{scope.row.customer_list_str_t}}</div>
                                                        </el-tooltip>
                                                    </template>
                                                <template v-else>
                                                    -
                                                </template>
                                            </div>
                                            <span v-else>{{scope.row[item.name]}}</span>
                                        </template>
                        
                                    </el-table-column>
                                    <el-table-column
                                        fixed="right"
                                        prop="action"
                                        align="center"
                                        label="操作"
                                        min-width="140">
                                        <template slot-scope="scope">
                                            <el-button type="primary" @click="handleEditClick(scope.row)" v-if="pageFuncNames.includes('enable')"  size="mini" class="action-btn">编辑</el-button>
                                            <el-button type="success" v-if="pageFuncNames.includes('enable')&&scope.row.status=='0'" @click="enableCustomerApp(scope.row)" :loading="scope.row.enableLoading" size="mini" class="action-btn">启用</el-button>
                                            <el-button type="danger" v-if="pageFuncNames.includes('disable')&&scope.row.status=='1'" @click="disableCustomerApp(scope.row)" :loading="scope.row.disableLoading" size="mini" class="action-btn">停用</el-button>
                                        </template>
                                    </el-table-column>
                                    <template slot="empty">
                                        <p class="tac">无符合条件的产品，若是新品，请点击 <el-button @click="handleAddAppClick" type="text">【录入新产品】</el-button>进行录入</p>
                                    </template>
                                </el-table>
                                <div class="page-bar tac mt10">
                                    <el-pagination
                                        @size-change="handleSizeChange"
                                        @current-change="handleCurrentChange"
                                        :current-page.sync="queryData.pn"
                                        :page-sizes="[30, 50,100]"
                                        :pager-count="5"
                                        layout="total, sizes, prev, pager, next, jumper"
                                        :total="totalCnt">
                                    </el-pagination>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- <UnbindListModal ref="unbindListModal" :is-disabled="!pageFuncNames.includes('bind_new_app')" :plat-list="platList" @update="updateUnbindData"/> -->
            <BatchBindModal ref="batchBindModal" :customer-data="activeCustomer" :app-list="dataSelected" @close="updateUnbindData" />
            <EnableResultModal ref="enableResultModal" :data-list="enableRowList" @confirm="confirmEnableApp"></EnableResultModal>
            <DisableResultModal ref="disableResultModal" @confirm="confirmDisableApp"></DisableResultModal>

        </template>
        <template v-else>
            <NoPermissionInfo>
                <p>可在此页面维护客户和产品之间的对应关系，为投放进行底层能力建设。</p>
            </NoPermissionInfo>
        </template>
    </div>
</template>

<script>
    import { mapState } from 'vuex';
    import {pageMixin} from '../../mixins/pageMixin';
    import NoPermissionInfo from '@/components/noPermissionInfo';
    import CompanyListCard from './components/companyListCard';
    // import UnbindListModal from './modal/unbindListModal';
    import BatchBindModal from './modal/batchBindModal';
    import EnableResultModal from './modal/enableResultModal';
    import DisableResultModal from './modal/disableResultModal';
    import API from '@/api/baseInfo/customerAppV2.js';

    import matomoFun from "@/utils/matomo.js";
    import { addAppModal, editAppModal, errDataTipModal, errAuthModal, editPersonInChargeModal } from './modal'
    export default {
        name: "CustomerAppPage",
        mixins: [pageMixin],
        components:{
            NoPermissionInfo,
            CompanyListCard,
            // UnbindListModal,
            BatchBindModal,
            EnableResultModal,
            DisableResultModal,
        },
        data(){
            return {
                tempQuery:{
                    search:'',
                    modify_time:'',
                },
                prePlatIds: window.localStorage.getItem('PLAT_IDS') ? Array.isArray(JSON.parse(window.localStorage.getItem('PLAT_IDS'))) ? '' : JSON.parse(window.localStorage.getItem('PLAT_IDS')) : '',
                queryData:{
                    search:'',
                    plat_ids:  window.localStorage.getItem('PLAT_IDS') ? Array.isArray(JSON.parse(window.localStorage.getItem('PLAT_IDS'))) ? '' : JSON.parse(window.localStorage.getItem('PLAT_IDS')) : '',
                    status:'',
                    special_app: window.localStorage.getItem('SPECIAL_APP') ??'4',
                    operator_ids:[],
                    modify_time:'',
                    is_auth: '',
                    app_type: '',
                    game_classify: '',
                    package_type: [],
                    creator_name: [],
                    modify_name: [],
                    other: { },
                    pn:1,
                    rn:30,
                    create_time: []
                },
                customerData:{
                    customer_id:'',
                    company_name:'',
                },
                tableHeight:300,
                totalCnt:0,
                operatorList:[],
                pickerOptions:{
                    firstDayOfWeek: 1,
                    disabledDate(time){
                        return time.getTime() > Date.now();
                    },
                    shortcuts:[
                        {
                            text: '今日',
                            onClick(picker) {
                                const end = new Date();
                                const start = new Date();
                                picker.$emit('pick', [start, end]);
                            }
                        },
                        {
                            text: '本周',
                            onClick(picker) {
                                // 本周：自然周，周一到周日
                                let date = new Date();
                                let year = date.getFullYear();
                                let month = date.getMonth()+1;
                                let day = date.getDate();
                                let weekDay = date.getDay();
                                let endDate = year+'-'+month+'-'+day;
                                let startD = new Date(date.getTime()-1000*60*60*24*(weekDay===0?6:weekDay-1));
                                let startDate = startD.getFullYear()+'-'+(startD.getMonth()+1)+'-'+startD.getDate();
                                picker.$emit('pick', [startDate, endDate]);
                            }
                        },
                        {
                            text: '本月',
                            onClick(picker) {
                                let date = new Date();
                                let year = date.getFullYear();
                                let month = date.getMonth()+1;
                                let day = date.getDate();
                                let startDate = year+'-'+month+'-1';
                                let endDate = year+'-'+month+'-'+day;
                                picker.$emit('pick', [startDate, endDate]);
                            }
                        },
                        {
                            text: '本季度',
                            onClick(picker) {
                                let date = new Date();
                                let year = date.getFullYear();
                                let month = date.getMonth()+1;
                                let day = date.getDate();
                                let startDate='';
                                if([1,2,3].includes(month)){
                                    startDate = year+'-01-01';
                                }else if([4,5,6].includes(month)){
                                    startDate = year+'-04-01';
                                }else if([7,8,9].includes(month)){
                                    startDate = year+'-07-01';
                                }else if([10,11,12].includes(month)){
                                    startDate = year+'-10-01';
                                }
                                let endDate = year+'-'+month+'-'+day;
                                picker.$emit('pick', [startDate, endDate]);
                            }
                        },
                    ]
                },
                dataSelected:[],
                dataList:[],
                dataLoading: true,
                unbindNum:0,
                activeCustomer:{},
                batchEnableLoading:false,
                batchDisableLoading:false,

                enableRowList:[],
                enableRowType:'',
                exportLoading:false,
                optionListData: {
                    'app_type':[],
                    'game_classify':[],
                    'package_type':[],
                    'is_auth':[],
                    'creator_name':[],
                    'modify_name':[],
                    'plat_id':[],
                    'modify_name':[],
                },
                column: [],
                formList: []
            }
        },
        computed:{
            ...mapState({
                sidebarOpened:state => state.app.sidebar.opened,
            }),
            platList(){
                return this.allowedPlatList.filter(item=>+item.id<=3||item.id==7 ||item.id==10 ||item.id==11);
            }
        },
        created(){
            this.getTableColumn()
            this.getFormConfig()
            this.getOperatorList();
           
        },
        mounted(){
            window.addEventListener("resize", this.calcTableHeight);
            this.calcTableHeight();
        },
        watch:{
            sidebarOpened(){
                setTimeout(()=>{
                    this.calcTableHeight();
                },100)
            },
        },
        beforeDestroy(){
            window.removeEventListener("resize", this.calcTableHeight);
        },
        methods:{
            // 批量修改负责人
            editPersonInCharge(){
                if (this.dataSelected.length === 0) {
                    this.$message.warning('请选择要修改负责人的客户产品');
                    return;
                };
                const onSubmit = ()=> {
                    this.getDataList();
                }
                editPersonInChargeModal({
                    props: {
                        dataSelected: this.dataSelected,
                    },
                    cbs: {
                        onSubmit
                    }
                })
            },
            platChange(val) {
                console.log('val', val);
                if (val) {
                    window.localStorage.setItem('PLAT_IDS', JSON.stringify(val))
                    this.prePlatIds = val;
                    this.submitSearch();
                }else {
                    this.$message.warning('至少选择一个媒体');
                    this.queryData.plat_ids = this.prePlatIds
                }
            },
            // 获取form表单配置
            getFormConfig() {
                API.getAppEntryField().then(res=>{
                    this.formList = res.data
                },error=>{
                    this.$message.error(error.info)
                })
            },
             // 列表
            async getTableColumn() {
                const { data } = await API.getAppEntryGetFiled({type: 'column'});
                this.column = data
                console.log('column', data)
                this.$nextTick(()=> {
                    this.$refs.dataTable.doLayout()
                })
            },
            // 编辑
            handleEditClick(row) {
                // if (row.is_auth==='1') {
                //     this.$message.error('已认证不可编辑，请前往标签管理或客户产品管理修改相关信息');
                //     return;
                // }
                const onSubmit = async ()=> {
                    vm.close()
                    this.submitSearch()
                }
                const { vm } = editAppModal({
                    props: {
                        appData: row
                    },
                    cbs: {
                        onSubmit
                    }
                })
            },
            // 添加产品
            handleAddAppClick() {
                const onSubmit = async (data, cb) => {
                    try {
                        await API.appEntryBatchAddApi(data);
                        vmadd.close()
                        this.$message.success('添加成功')
                        this.handleCurrentChange(1)
                    } catch (error) {
                        if (error.data.error.length>0) {
                            const callback = (arr)=> {
                                console.log('callback', vmadd.$refs)
                                const list = data.app_info.filter((v,i)=> {
                                    return !arr.includes(i+1)
                                });
                                vmadd.$refs.componentVm.del(arr)
                                if (list.length>0) {
                                    cb(true)
                                    vm.close()
                                    onSubmit({...data, app_info: list}, cb)
                                    
                                }else {
                                    vm.close()
                                    this.$message.error('请重新复制新的数据，当前数据已全部存在')
                                }
                            }
                            const { vm } = errDataTipModal({
                                width: '800px',
                                props: {
                                    title: error.info,
                                    list: error.data.error.map(v=> {
                                        return {
                                            tip: v.error_msg,
                                            error_num: v.error_num,
                                            index: v.error_num
                                        }
                                    }),
                                    authList: [],
                                    entryList: [],
                                    remove: data.add_type ==='2' && !!error.remove,
                                    hasNum: data.add_type ==='2'
                                },
                                cbs: {
                                    onSubmit: callback
                                }
                            })
                        }else {
                            const callback_error = (arr) => {
                                const list = data.app_info.filter((v, i) => {
                                    return !arr.includes(i + 1)
                                });
                                console.log('callback1', vmadd.$refs)
                                vmadd.$refs.componentVm.del(arr)
                                if (list.length > 0) {
                                    cb(true)
                                    vm_error.close()
                                    onSubmit({ ...data, app_info: list }, cb)

                                } else {
                                    vm_error.close()
                                    this.$message.error('请重新复制新的数据，当前数据已全部存在')
                                }
                            }
                            const { vm: vm_error } = errDataTipModal({
                                width: '800px',
                                props: {
                                    title: error.info,
                                    list: [
                                        {
                                            tip: '',
                                            error_num: error.data.err_list.error_num,
                                            index: error.data.err_list.error_num
                                        }
                                    ],
                                    authList: error.data.err_list.auth_err || [],
                                    entryList: error.data.err_list.entry_err || [],
                                    remove: data.add_type === '2' && !!error.remove,
                                    hasNum: data.add_type === '2'
                                },
                                cbs: {
                                    onSubmit: callback_error
                                }
                            })
                        }
                    }finally {
                        cb()
                    }
                }
                
                const { vm:vmadd } = addAppModal({
                    props: {
                        
                    },
                    cbs: {
                        onSubmit
                    }
                })
            },
            specialAppChange(val) {
                window.localStorage.setItem('SPECIAL_APP', val);
                this.submitSearch();
            },
            calcTableHeight(){
                let $filterBar = document.querySelector('.filter-bar');
                let filterBarHeight = $filterBar?$filterBar.clientHeight:0;
                let height = window.innerHeight - 70 - filterBarHeight - 45 - 52 - 20;
                this.$nextTick(()=>{
                    this.tableHeight = height;
                })
            },
            updateUnbindData(){
                // 更新列表数据
                this.getDataList();
                // 更新客户list
                this.$refs.companyListCard.getDataList();
            },
            changeCustomer(item){
                console.log('changeCustomer',item);
                this.activeCustomer = item;
                this.submitSearch();
            },
            getOperatorList(){
                const search_type = [
                    'app_type',
                    'game_classify',
                    'package_type',
                    'is_auth',
                    'creator_name',
                    'modify_name',
                    'plat_id',
                ]
                const params = {
                    search_type,
                }
                API.getSearchList(params).then(res=>{
                    console.log('getOperatorList',res);
                    // this.operatorList = res.data||[];
                    this.optionListData = res.data||{};
                    if(res.data.plat_id?.length && (!window.localStorage.getItem('PLAT_IDS') || Array.isArray(JSON.parse(window.localStorage.getItem('PLAT_IDS'))))) {
                        const list = res.data.plat_id[0].id;
                        this.queryData.plat_ids = list
                        this.prePlatIds = list
                    }
                    this.submitSearch();
                },err=>{
                    this.submitSearch();
                    console.log('getOperatorList err',err);
                    this.$message.error(err.info||'请求失败');
                    // this.operatorList = [];
                })
            },
            submitSearch(){
                console.log('submitSearch');
                matomoFun.trackEvent('客户产品管理', '点击', '筛选');
                this.queryData.pn = 1;
                this.queryData.search = this.tempQuery.search;
                this.queryData.modify_time = this.tempQuery.modify_time?this.tempQuery.modify_time.join('/'):'';
                this.getDataList();
            },
            changeData(val, key){
                if(val.includes('all-option')){
                    this.queryData[key] = (this.optionListData[key] || []).map(item=>item.id);
                }else{
                    this.queryData[key] = val;
                }
                this.submitSearch();
            },
            getDataList(){
                this.dataLoading = true;
                API.getCustomerAppList({
                    customer_id: this.activeCustomer.customer_id,
                    search: this.queryData.search,
                    plat_ids: this.queryData.plat_ids,
                    status: this.queryData.status,
                    special_app: this.queryData.special_app,
                    operator_ids: this.queryData.operator_ids.join(','),
                    modify_time: this.queryData.modify_time,
                    create_time: (this.queryData.create_time || []).join('/'),
                    creator_name: this.queryData.creator_name.join(','),
                    modify_name: this.queryData.modify_name.join(','),
                    game_classify: this.queryData.game_classify,
                    package_type: this.queryData.package_type.join(','),
                    is_auth: this.queryData.is_auth,
                    app_type: this.queryData.app_type,
                    other: this.queryData.other,
                    pn:this.queryData.pn,
                    rn:this.queryData.rn,
                }).then(res => {
                    let resData = res.data || {};
                    this.dataLoading = false;
                    this.dataList = (resData.list||[]).map(item=>{
                        item.disableLoading = false;
                        item.enableLoading = false;
                        return item;
                    });
                    this.totalCnt = resData.totalCnt;
                }, (err) => {
                    console.log('getUserList error', err);
                    this.dataList = [];
                    this.dataLoading = false;
                    this.totalCnt = 0;
                });
            },
            selectionChange(val){
                this.dataSelected = val.map(item => item);
            },
            handleSizeChange(val) {
                this.queryData.rn = val;
                this.getDataList();
            },
            handleCurrentChange(val) {
                this.queryData.pn = val;
                this.getDataList();
            },
            showUnbindListModal(){
                this.$refs.unbindListModal.showModal();
            },
            showBatchBindModal(){
                console.log('showBatchBindModal');
                this.$refs.batchBindModal.showModal();
            },
            batchEnable(){
                console.log('batch',this.dataSelected);
                if(this.dataSelected.length<=0) return false;

                let availableData = this.dataSelected.filter(item=>item.status=='0');
                if(availableData.length<=0) return this.$message.error('所选产品已经是启用状态');

                this.enableRowType = 'batch';
                this.enableRowList = [...availableData];
                this.batchEnableLoading = true;
                API.enableCustomerApp({
                    is_auth_plat_id_id_customer_id:availableData.map(item=>`${item.is_auth}-${item.plat_id}-${item.id}-${item.customer_id}`)
                }).then(res => {
                     this.batchEnableLoading = false;
                    console.log('enableCustomerApp',res);
                    let resData = res.data||[];
                    if(resData.length>0){
                        this.$refs.enableResultModal.showModal(resData);
                    }else{
                        this.$message.success(res.info||'操作成功');
                        this.getDataList();
                    }
                }, (err) => {
                    if(err.data?.error_list) {
                        errAuthModal({
                            props: {
                                list: err.data?.error_list
                            }
                        });
                        this.batchEnableLoading = false;
                        return;
                    }
                     this.batchEnableLoading = false;
                    console.log('enableCustomerApp err',err);
                    this.enableRowList = [];
                    this.$message.error(err.info||'操作失败');
                });
            },
            batchDisable(){
                console.log('batch',this.dataSelected);
                if(this.dataSelected.length<=0) return false;

                let availableData = this.dataSelected.filter(item=>item.status=='1');
                if(availableData.length<=0) return this.$message.error('所选产品已经是停用状态');

                this.batchDisableLoading = true;
                API.disableCustomerApp({
                    is_auth_plat_id_id_customer_id:availableData.map(item=>`${item.is_auth}-${item.plat_id}-${item.id}-${item.customer_id}`)
                }).then(res => {
                     this.batchDisableLoading = false;
                    console.log('disableCustomerApp',res);
                    let resData = res.data||[];
                    if(resData.length>0){
                        this.$refs.disableResultModal.showModal(resData);
                    }else{
                        this.$confirm('<div><p>您确认要停用该客户的绑定关系吗?</p></div>','提示',{
                            confirmButtonText: '停用',
                            cancelButtonText: '取消',
                            type: 'warning',
                            confirmButtonClass:'danger-button',
                            dangerouslyUseHTMLString: true,
                            customClass:'wide-confirm-box-550',
                        }).then(()=>{
                            matomoFun.trackEvent('客户产品管理', '点击', '停用(提交)');
                            this.batchDisableLoading = true;
                            API.disableCustomerApp({
                                is_auth_plat_id_id_customer_id:availableData.map(item=>`${item.is_auth}-${item.plat_id}-${item.id}-${item.customer_id}`),
                                confirm:'1',
                            }).then(res1=>{
                                this.getDataList();
                                console.log('disableCustomerApp',res1);
                                this.$message.success(res1.info||'操作成功');
                                this.batchDisableLoading = false;
                            },err1=>{
                                 if(err1.data?.error_list) {
                                    errAuthModal({
                                        props: {
                                            list: err1.data?.error_list
                                        }
                                    });
                                    this.batchDisableLoading = false;
                                    return;
                                }
                                this.batchDisableLoading = false;
                                console.log('disableCustomerApp err',err1);
                                this.$message.error(err1.info||'操作失败');
                            })
                        }).catch(()=>{
                            console.log('取消');
                            matomoFun.trackEvent('客户产品管理', '点击', '停用(取消)');
                        });
                    }
                }, (err) => {
                     if(err.data?.error_list) {
                        errAuthModal({
                            props: {
                                list: err.data?.error_list
                            }
                        });
                        this.batchDisableLoading = false;
                        return;
                    }
                     this.batchDisableLoading = false;
                    console.log('disableCustomerApp err',err);
                    this.$message.error(err.info||'操作失败');
                });
            },
            enableCustomerApp(row){
                console.log('enableCustomerApp',row);
                row.enableLoading = true;
                this.enableRowType = '';
                this.enableRowList = [row];

                API.enableCustomerApp({
                    is_auth_plat_id_id_customer_id:[`${row.is_auth}-${row.plat_id}-${row.id}-${row.customer_id}`]
                }).then(res => {
                    let resData = res.data||[];
                    row.enableLoading = false;
                    if(resData.length>0){

                        this.$refs.enableResultModal.showModal(resData);
                    }else{
                        this.$message.success(res.info||'操作成功');
                        this.enableRowList = [];
                        this.getDataList();
                    }
                }, (err) => {
                    if(err.data?.error_list) {
                        errAuthModal({
                            props: {
                                list: err.data?.error_list
                            }
                        });
                        row.enableLoading = false;
                        return;
                    }
                    row.enableLoading = false;
                    console.log('enableCustomerApp err',err);
                    this.$message.error(err.info||'操作失败');
                });
            },
            confirmEnableApp(val){
                let isBatch = this.enableRowType =='batch';
                console.log('confirmEnableApp',isBatch);
                if(isBatch){
                    this.batchEnableLoading = true;
                }
                this.enableRowList.forEach(row=>{
                    let rowItem = this.dataList.find(item=>item.plat_id==row.plat_id&&item.subitem_id==row.subitem_id);
                    this.$set(rowItem,'enableLoading',true);
                });
                API.enableCustomerApp({
                    is_auth_plat_id_id_customer_id:this.enableRowList.map(row=>`${row.is_auth}-${row.plat_id}-${row.id}-${row.customer_id}`),
                    confirm:val,
                }).then(res => {
                    this.$message.success(res.info||'操作成功');
                    if(isBatch){
                        this.batchEnableLoading = false;
                    }
                    this.getDataList();
                }, (err) => {
                    if(isBatch){
                        this.batchEnableLoading = false;
                    }
                    this.enableRowList.forEach(row=>{
                        let rowItem = this.dataList.find(item=>item.plat_id==row.plat_id&&item.subitem_id==row.subitem_id);
                        this.$set(rowItem,'enableLoading',false);
                    });
                    console.log('enableCustomerApp err',err);
                    this.$message.error(err.info||'操作失败');
                });
            },
            confirmDisableApp(val){
                this.batchDisableLoading = true;
                let availableData = this.dataSelected.filter(item=>item.status=='1');
                API.disableCustomerApp({
                    is_auth_plat_id_id_customer_id:availableData.map(row=>`${row.is_auth}-${row.plat_id}-${row.id}-${row.customer_id}`),
                    confirm:val,
                }).then(res => {
                    this.$message.success(res.info||'操作成功');
                    this.getDataList();
                    this.batchDisableLoading = false;
                }, (err) => {
                    this.batchDisableLoading = false;
                    // this.dataSelected.forEach(row=>{
                    //     let rowItem = this.dataList.find(item=>item.plat_id==row.plat_id&&item.subitem_id==row.subitem_id);
                    //     this.$set(rowItem,'enableLoading',false);
                    // });
                    console.log('enableCustomerApp err',err);
                    this.$message.error(err.info||'操作失败');
                });
            },
            disableCustomerApp(row){
                console.log('disableCustomerApp',row);
                row.disableLoading = true;
                API.disableCustomerApp({
                    is_auth_plat_id_id_customer_id:[`${row.is_auth}-${row.plat_id}-${row.id}-${row.customer_id}`]
                }).then(res => {
                    row.disableLoading = false;

                    let resData = res.data||[];
                    let htmlStr = '';

                    if(resData.length>0){
                        htmlStr = '<div><p>当前产品已无其他启用的绑定客户，您确认要停用吗?</p></div>';
                    }else{
                        htmlStr = '<div><p>您确认要停用该客户的绑定关系吗?</p></div>';
                    }

                    this.$confirm(htmlStr,'提示',{
                        confirmButtonText: '停用',
                        cancelButtonText: '取消',
                        type: 'warning',
                        confirmButtonClass:'danger-button',
                        dangerouslyUseHTMLString: true,
                        customClass:'wide-confirm-box-550',
                    }).then(()=>{
                        row.disableLoading = true;
                        API.disableCustomerApp({
                            is_auth_plat_id_id_customer_id:[`${row.is_auth}-${row.plat_id}-${row.id}-${row.customer_id}`],
                            confirm:'1',
                        }).then(res1=>{
                            this.getDataList();
                            console.log('disableCustomerApp',res1);
                            this.$message.success(res1.info||'操作成功');
                        },err1=>{
                            if(err1.data?.error_list) {
                                errAuthModal({
                                    props: {
                                        list: err1.data?.error_list
                                    }
                                });
                                row.disableLoading = false;
                                return;
                            }   
                            row.disableLoading = false;
                            console.log('disableCustomerApp err',err1);
                            this.$message.error(err1.info||'操作失败');
                        })
                    }).catch(()=>{
                        console.log('取消');
                    });
                }, (err) => {
                    if(err.data?.error_list) {
                        errAuthModal({
                            props: {
                                list: err.data?.error_list
                            }
                        });
                        row.disableLoading = false;
                        return;
                    }
                    row.disableLoading = false;
                    console.log('disableCustomerApp err',err);
                    this.$message.error(err.info||'操作失败');
                });
            },
            exportData(){
                this.exportLoading = true;
                API.getCustomerAppList({
                    export:'1',
                    customer_id: this.activeCustomer.customer_id,
                    search: this.queryData.search,
                    plat_ids: this.queryData.plat_ids,
                    status: this.queryData.status,
                    special_app: this.queryData.special_app,
                    operator_ids: this.queryData.operator_ids.join(','),
                    modify_time: this.queryData.modify_time,
                    create_time: (this.queryData.create_time || []).join('/'),
                    creator_name: this.queryData.creator_name.join(','),
                    modify_name: this.queryData.modify_name.join(','),
                    game_classify: this.queryData.game_classify,
                    package_type: this.queryData.package_type.join(','),
                    is_auth: this.queryData.is_auth,
                    app_type: this.queryData.app_type,
                    other: this.queryData.other,
                    pn:this.queryData.pn,
                    rn:this.queryData.rn,
                }).then(res => {
                    this.exportLoading = false;
                    this.$message.success(res.info||'操作成功');
                }, (err) => {
                    this.exportLoading = false;
                    let errData = err.data||[];
                    if(err.code==0&&errData.length>0){
                        this.$notify.error({
                            title: err.info||'请求失败',
                            message: errData.join('；'),
                            duration: 0
                        });
                    }else{
                        this.$message.error(err.info||'操作失败');
                    }
                });
            },
        }
    }
</script>

<style lang="scss" scoped>
    .wrap {
        display: flex;
    }

    .left {
       
        background-color: #fff;
        box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);

    }

    .right {
        background-color: #fff;
        margin-left: 10px;
        flex: 1;
        .filter-bar{
            background-color: #f8f8f9;
            padding: 12px 20px 0;
            border-radius: 5px;
            ::v-deep .el-form-item{
                margin-bottom: 12px;
            }
        }
        .top10{
            top:10px;
        }
        .table-wrap::v-deep .el-table{
            background-color: #f8f8f9;
            .el-button.is-disabled {
                color: #999!important;
            }
        }

        .vertical-bottom{
            vertical-align: bottom;
        }
        .action-btn{
            padding: 5px 10px;
        }
        .no-pointer{
            cursor: default;
        }



        .info-tip-icon{
            font-weight: bold;
            font-size: 24px;
            vertical-align: middle;
        }

        ::v-deep .el-table__cell{
            padding: 5px 0;
        }
    }

</style>
